<template>
  <div class="image-input">
    <input
      type="file"
      style="display: none"
      ref="fileInputElement"
      @change="pickFile"
      accept="image/png, image/jpeg"
    />
    <loading :show="loading">
      <button type="button" :style="buttonStyle" @click="openFilePicker">
        <i v-if="!url" class="fa-regular fa-user"></i>
        <div class="edit">
          <i class="fa-solid fa-pen-to-square"></i>
        </div>
      </button>
    </loading>
  </div>
</template>
<script>
export default {
  props: {
    url: String,
    loading: Boolean
  },
  data() {
    return {
      fileInputElement: null
    };
  },
  computed: {
    buttonStyle() {
      const style = {};
      if (this.url) {
        style["background-image"] = `url(${this.url})`;
      }
      return style;
    }
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInputElement.click();
    },
    pickFile(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile.size > 1000000) {
        this.$message.error("Imagem muito grande. Tamanho máximo: 1MB");
        return;
      }
      if (
        selectedFile &&
        ["image/png", "image/jpeg"].includes(selectedFile.type)
      ) {
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          () => {
            this.$emit("pick", reader.result);
          },
          false
        );
        reader.readAsDataURL(selectedFile);
      } else {
        this.$message.error("Formato de arquivo inválido");
      }
      event.target.value = ""; // Reseta o input
    }
  }
};
</script>
<style lang="scss" scoped>
.image-input {
  button {
    background-color: #999;
    background-size: cover;
    background-position: center center;
    border: none;
    padding: 0;
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 100%;
    .fa-user {
      font-size: 60px;
      color: white;
    }
    .edit {
      opacity: 0;
      padding: 12px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(
        0deg,
        rgba(169, 180, 234, 0.75) 13.6%,
        rgba(169, 180, 234, 0.3) 73.6%
      );
      border-radius: 100%;
      transition: opacity 0.2s;
      i {
        font-size: 20px;
      }
    }
    &:hover {
      .edit {
        opacity: 1;
      }
    }
  }
}
</style>
